import { Component, Input } from "@angular/core"

@Component({
	selector: "app-modal-error",
	templateUrl: "./modal-error.component.html",
	styleUrls: ["./modal-error.component.scss"]
})
export class ModalErrorComponent {
	@Input() errorText: string
}
